export const SHOW_ALL_FILTER_NAME = 'Alle anzeigen';
